import { Button } from '@civilgrid/ui/components';
import { useState } from 'react';
import { getAIProjectDescription } from '~/api/civilsearch';

const RefreshAiProjectDescriptionButton = ({
  setProjectDescription,
  projectId,
}: {
  setProjectDescription: (s: string) => void;
  projectId: string;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <Button
      variant="secondary"
      loading={isLoading}
      data-testid="refresh-ai-project-description"
      onClick={async () => {
        setIsLoading(true);
        await getAIProjectDescription(projectId, true)
          .then((description) => setProjectDescription(description))
          .catch((err) => console.error(err))
          .finally(() => setIsLoading(false));
      }}
    >
      Refresh
    </Button>
  );
};

export default RefreshAiProjectDescriptionButton;
